var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 29,
    viewBox: "0 0 43 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1271_1812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.972656 4.39681C0.972656 2.48197 2.52494 0.929688 4.43978 0.929688H39.111C41.0258 0.929688 42.5781 2.48197 42.5781 4.39681V25.1995C42.5781 27.1144 41.0258 28.6666 39.111 28.6666H4.43978C2.52494 28.6666 0.972656 27.1144 0.972656 25.1995V4.39681Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.832 10.6436H32.0806C31.5511 10.6436 31.1438 10.8065 30.8995 11.336L27.5596 18.9525H29.9219C29.9219 18.9525 30.3292 17.9343 30.4107 17.6899C30.6551 17.6899 32.9767 17.6899 33.3025 17.6899C33.384 17.975 33.5877 18.9118 33.5877 18.9118H35.7056L33.832 10.6436ZM31.0624 15.9792C31.266 15.4905 31.9584 13.6576 31.9584 13.6576C31.9584 13.6983 32.1621 13.1688 32.2436 12.8837L32.4065 13.6169C32.4065 13.6169 32.8545 15.6127 32.936 16.02H31.0624V15.9792Z",
    fill: "#3362AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7222 16.2237C27.7222 17.9344 26.1745 19.0749 23.7714 19.0749C22.7531 19.0749 21.7756 18.8712 21.2461 18.6268L21.5719 16.7532L21.857 16.8754C22.5902 17.2013 23.079 17.3234 23.975 17.3234C24.6267 17.3234 25.3191 17.0791 25.3191 16.5088C25.3191 16.1423 25.034 15.8979 24.1379 15.4906C23.2826 15.0833 22.1422 14.4316 22.1422 13.2504C22.1422 11.6212 23.7306 10.5215 25.9708 10.5215C26.8261 10.5215 27.5593 10.6844 28.0073 10.8881L27.6815 12.6802L27.5186 12.5173C27.1113 12.3543 26.5818 12.1914 25.8079 12.1914C24.9526 12.2322 24.5452 12.5987 24.5452 12.9246C24.5452 13.2911 25.034 13.5763 25.8079 13.9428C27.1113 14.5538 27.7222 15.2462 27.7222 16.2237Z",
    fill: "#3362AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8457 10.7254L7.88643 10.5625H11.3892C11.878 10.5625 12.2446 10.7254 12.3668 11.2549L13.1406 14.9206C12.3668 12.9656 10.5746 11.3771 7.8457 10.7254Z",
    fill: "#F9B50B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0691 10.6433L14.5255 18.9115H12.1225L10.0859 11.9874C11.5522 12.9242 12.7741 14.3905 13.2222 15.4087L13.4666 16.2641L15.666 10.6025H18.0691V10.6433Z",
    fill: "#3362AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0066 10.6025H21.2468L19.8212 18.9115H17.5811L19.0066 10.6025Z",
    fill: "#3362AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_1812"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.972656,
    y: 0.929688,
    width: 41.6054,
    height: 27.737,
    rx: 5.77853,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.953d67ffe9a6531aa72c48f5dbdd22da.svg";
export { ForwardRef as ReactComponent };